import { Body1, Tag } from "@fluentui/react-components";
import { memo } from "react";

export const RenderTagListing = memo(
  ({ tags, className }: { tags: Array<{ id: string; name: string }>; className: string }) => {
    return (
      <Body1 className={className}>
        {tags.map((tag: any) => (
          <Tag size="small" key={tag.id} appearance="outline">
            {tag.name}
          </Tag>
        ))}
      </Body1>
    );
  }
);
